module.exports = __webpack_public_path__ + "static/media/Oswald-SemiBold.80060728.ttf";